/* eslint-disable func-names */
/* eslint-disable default-param-last */
import { assign } from 'lodash';
import { LOAD_CLIENT, SET_SOOTHE_PASS_DISCOUNT_AVAILABILITY } from '../Actions';

export default function (state = {}, action) {
  switch (action.type) {
    case LOAD_CLIENT:
      return action.payload;
    case SET_SOOTHE_PASS_DISCOUNT_AVAILABILITY:
      return assign({}, state, action.payload);
    default:
      return state;
  }
}
